export default "__VITE_ASSET__BXnwuNCp__"